import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AuthService } from '../core/service/auth.service';

export interface NavEntry {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatTooltipModule, TranslateModule, HeaderComponent, FooterComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  navOpen = false;

  readonly navItems: NavEntry[];

  constructor(auth: AuthService) {
    this.navItems = [
      { label: 'NAV.NEW_SELECTION', icon: 'add_box', route: '/selection' },
      { label: 'NAV.SAVED_SELECTIONS', icon: 'save', route: '/saved' },
      ...(auth.getUserLevel().canAccessAdmin ? [{ label: 'NAV.ADMIN_PANEL', icon: 'admin_panel_settings', route: '/admin' }] : []),
    ];
  }

  trackByRoute(_index: number, item: NavEntry): string {
    return item.route;
  }

  toggleNav(): void {
    this.navOpen = !this.navOpen;
  }

  closeNavIfOpen(): void {
    if (this.navOpen) {
      this.navOpen = false;
    }
  }
}
